import * as React from "react"
import { connect } from "react-redux"

import { GlobalState } from "../../../store"
import bem from "../../../bem"
import GridComponent from "../../common/grid/GridComponent"

const b = bem.with("NewUI__coverPage")

interface StateProps {
    grid: Grids.Grid
    isLoading: boolean
    bookmarks: Record<string, Models.Bookmark>
    shortcuts: Record<string, Models.Shortcut>
}

type Props = StateProps

export class CoverPage extends React.Component<Props> {
    render(): JSX.Element {
        const { bookmarks, shortcuts, grid, isLoading } = this.props

        return (
            <div
                className={`${b()} tw-p-2 ${
                    isLoading ? "is-placeholder is-loading" : ""
                }`}
            >
                <GridComponent
                    tiles={grid.tiles}
                    isLoading={isLoading}
                    bookmarks={bookmarks}
                    shortcuts={shortcuts}
                    shouldShowWorkspaceScreenLabel={false}
                />
            </div>
        )
    }
}

const mapStateToProps = (state: GlobalState): StateProps => ({
    grid: state.workspaceCoverPage.grid,
    bookmarks: state.bookmarks.bookmarks,
    shortcuts: state.shortcuts.shortcuts,
    isLoading: state.workspaceCoverPage.isLoading,
})

export default connect(mapStateToProps, {})(CoverPage)
